import { render, staticRenderFns } from "./MyTrashes.vue?vue&type=template&id=bf255824&scoped=true"
import script from "./MyTrashes.vue?vue&type=script&lang=js"
export * from "./MyTrashes.vue?vue&type=script&lang=js"
import style0 from "./MyTrashes.vue?vue&type=style&index=0&id=bf255824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf255824",
  null
  
)

export default component.exports